import { useEffect, useState } from "react";

const useResponsive = () => {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return {
    isMobile: width <= 480,
    isTablet: width > 480 && width <= 767,
    isSmallLaptop: width > 767 && width <= 991,
    isDesktop: width > 991 && width <= 1199,
    isLargeScreen: width > 1199,
    width
  };
};

export default useResponsive;
